import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVideoOff"><Path d="M15.25 12V10L19.8028 7.72361C20.4677 7.39116 21.25 7.87465 21.25 8.61803V15.382C21.25 16.1253 20.4677 16.6088 19.8028 16.2764L15.25 14V12ZM15.25 12V7.75C15.25 6.09315 13.9069 4.75 12.25 4.75H7.75M3.82872 5.44584C3.16946 5.99615 2.75 6.82409 2.75 7.75V16.25C2.75 17.9069 4.09315 19.25 5.75 19.25H12.25C12.9867 19.25 13.6613 18.9845 14.1835 18.5439M2 3L16.5 21.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVideoOff;
